import { render, staticRenderFns } from "./VContractHistory.vue?vue&type=template&id=3bac3462&"
import script from "./VContractHistory.vue?vue&type=script&lang=js&"
export * from "./VContractHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports